
































import Vue from "vue";
import { Order } from "../models/Order";
export default Vue.extend({
  props: {
    value: {
      type: Object as () => Order
    }
  },
  computed: {
    orderInfo: {
      get(): Order {
        return (this as any).value;
      }
    }
  }
});
